export default __webpack_public_path__ + "static/media/teachers_piechart.0a91f6f9.svg";